import React from 'react';
import VerifyCode from "../../../Code/VerifyCode";
import PasswordForm from "../../../Login/PasswordForm";

class CompleteLoginView extends React.Component {
    render() {
        return (
            <>
                {(this.props.showForm === "PASSWORD" || this.props.step === "PASSWORD") ?
                    <PasswordForm
                        style={this.props.style}
                        username={this.props.username}
                        savePayload={this.props.savePayload}
                        payload={this.props.payload}
                        signInType={this.props.signInType}
                        displayForm={this.props.displayForm}
                        showForm={this.props.showForm}
                        saveStep={this.props.saveStep}
                        acr_values={this.props.acr_values}
                    />
                    :
                    <VerifyCode style={this.props.style}
                        finishAuth={true}
                        signInType={this.props.signInType}
                        payload={this.props.payload}
                        savePayload={this.props.savePayload}
                        savePhone={this.props.savePhone}
                        saveEmail={this.props.saveEmail}
                        displayForm={this.props.displayForm}
                        showForm={this.props.showForm}
                        saveStep={this.props.saveStep}
                        acr_values={this.props.acr_values}
                    />
                }
            </>
        );
    }
}

export default CompleteLoginView;